const list = [
  // 用户管理
  {
    name: "直播管理",
    menuItem: {
      name: "直播管理",
      iconClass: "el-icon-video-camera-solid",
      route: "/live-list",
    },
  },
  {
    name: "房间列表",
    menuItem: {
      name: "房间列表",
      iconClass: "el-icon-user",
      route: "/live-room",
    },
  },
  {
    name: "直播列表",
    menuItem: {
      name: "直播列表",
      iconClass: "el-icon-user",
      route: "/live-list",
    },
  },
  {
    name: "直播课程",
    menuItem: {
      name: "直播课程",
      iconClass: "el-icon-user",
      route: "/live-couse",
    },
  },
  {
    name: "付费记录",
    menuItem: {
      name: "付费记录",
      iconClass: "el-icon-user",
      route: "/live-pay",
    },
  },
  // 直播end
  // 运营管理
  {
    name: "营运管理",
    menuItem: {
      name: "营运管理",
      iconClass: "el-icon-s-data",
      route: "/swiper",
    },
  },
  {
    name: "轮播图管理",
    menuItem: {
      name: "轮播图管理",
      iconClass: "el-icon-user",
      route: "/swiper",
    },
  },
  {
    name: "手机号管理",
    menuItem: {
      name: "手机号管理",
      iconClass: "el-icon-user",
      route: "/phone",
    },
  },
  {
    name: "优惠券管理",
    menuItem: {
      name: "优惠券管理",
      iconClass: "el-icon-user",
      route: "/coupon",
    },
  },
  {
    name: "学校风采",
    menuItem: {
      name: "学校风采",
      iconClass: "el-icon-user",
      route: "/school-style",
    },
  },
  {
    name: "学员风采",
    menuItem: {
      name: "学员风采",
      iconClass: "el-icon-user",
      route: "/student-style",
    },
  },
  {
    name: "分类管理",
    menuItem: {
      name: "分类管理",
      iconClass: "el-icon-user",
      route: "/classification",
    },
  },
  // 营运end============
  {
    name: "学员管理",
    menuItem: {
      name: "学员管理",
      iconClass: "el-icon-s-custom",
      route: "/student-list",
    },
  },
  {
    name: "老师管理",
    menuItem: {
      name: "老师管理",
      iconClass: "el-icon-s-custom",
    },
  },
  {
    name: "授课老师",
    menuItem: {
      name: "授课老师",

      route: "/teacher-list",
    },
  },
  {
    name: "责任老师",
    menuItem: {
      name: "责任老师",
      iconClass: "el-icon-user",
      route: "/teacher-responsible",
    },
  },
  {
    name: "分校管理",
    menuItem: {
      name: "分校管理",
      iconClass: "el-icon-school",
      route: "/school-list",
    },
  },
  {
    name: "用户管理",
    menuItem: {
      name: "用户管理",
      iconClass: "el-icon-user",
      route: "/user-manage",
    },
  },
  {
    name: "用户列表",
    menuItem: {
      name: "用户列表",
      iconClass: "el-icon-user",
      route: "/user-list",
    },
  },

  // 权限管理
  {
    name: "权限管理",
    menuItem: {
      name: "权限管理",
      iconClass: "el-icon-lock",
      route: "/role-list",
    },
  },
  {
    name: "管理员管理",
    menuItem: {
      name: "管理员管理",
      route: "/admin-list",
    },
  },
  {
    name: "角色管理",
    menuItem: {
      name: "角色管理",
      route: "/role-list",
    },
  },
  {
    name: "菜单管理",
    menuItem: {
      name: "菜单管理",
      route: "/menu-list",
    },
  },
  {
    name: "操作日志",
    menuItem: {
      name: "操作日志",
      route: "/operation-log",
    },
  },
  // 教务管理
  {
    name: "教务管理",
    menuItem: {
      name: "教务管理",
      iconClass: "el-icon-collection",
      route: "/jwgl",
    },
  },
  {
    name: "课程列表",
    menuItem: {
      name: "课程列表",

      route: "/course-list",
    },
  },
  {
    name: "线下考试",
    menuItem: {
      name: "线下考试",

      route: "/offline-exam",
    },
  },
  {
    name: "线上考试",
    menuItem: {
      name: "线上考试",

      route: "/online-exam",
    },
  },
  {
    name: "证书列表",
    menuItem: {
      name: "证书列表",

      route: "/certificate",
    },
  },
  {
    name: "签到列表",
    menuItem: {
      name: "签到列表",

      route: "/sign-list",
    },
  },
  {
    name: "补课申请",
    menuItem: {
      name: "补课申请",

      route: "/make-up",
    },
  },
  {
    name: "考卷分类",
    menuItem: {
      name: "考卷分类",

      route: "/paper-cate",
    },
  },
  {
    name: "题库管理",
    menuItem: {
      name: "题库管理",

      route: "/online-topic",
    },
  },
  {
    name: "考卷科目",
    menuItem: {
      name: "考卷科目",
      route: "/exam-subject",
    },
  },
  // 数据分析
  {
    name: "数据分析",
    menuItem: {
      name: "数据分析",
      iconClass: "el-icon-s-marketing",
      route: "/sjfx",
    },
  },
  {
    name: "财务汇总",
    menuItem: {
      name: "财务汇总",

      route: "/finance",
    },
  },
  {
    name: "用户分析",
    menuItem: {
      name: "用户分析",

      route: "/user-analysis",
    },
  },
  {
    name: "证书统计",
    menuItem: {
      name: "证书统计",

      route: "/certificate-analysis",
    },
  },
  {
    name: "学习统计",
    menuItem: {
      name: "学习统计",
      route: "/learn-analysis",
    },
  },
  {
    name: "订单管理",
    menuItem: {
      name: "订单管理",
      iconClass: "el-icon-tickets",
      route: "/ddgl",
    },
  },
  {
    name: "课程订单",
    menuItem: {
      name: "课程订单",

      route: "/course-order",
    },
  },
  {
    name: "商品订单",
    menuItem: {
      name: "商品订单",

      route: "/product-order",
    },
  },
  {
    name: "培训计划",
    menuItem: {
      name: "培训计划",

      route: "/order-train",
    },
  },
  {
    name: "培训记录",
    menuItem: {
      name: "培训记录",

      route: "/order-trainlog",
    },
  },
  {
    name: "书斋管理",
    menuItem: {
      name: "书斋管理",
      iconClass: "el-icon-tickets",
      route: "/product",
    },
  },
  {
    name: "商品列表",
    menuItem: {
      name: "商品列表",

      route: "/product",
    },
  },
  {
    name: "敏感词库",
    menuItem: {
      name: "敏感词库",
      iconClass: "el-icon-tickets",
      route: "/word",
    },
  },
  {
    name: "商品分类",
    menuItem: {
      name: "商品分类",

      route: "/product-type",
    },
  },
];
const mapper = new Map();
list.forEach((value) => {
  mapper.set(value.name, value.menuItem);
});

export default mapper;
